import { Component, Input, OnInit } from '@angular/core';
import { DialogManagerService } from '@src/services';
import { MessageDialogComponent } from '@app/shared/components/dialogs/message-dialog/message-dialog.component';

@Component({       
    selector: 'dbm-additional-options-proprties',
    template: require('./dbm-additional-proprties.component.html'),
    styles: [require('./dbm-additional-proprties.component.scss')]
})
export class DbmAdditionalProprtiesOptionsComponent implements OnInit {
    @Input() public isOpenEditMode: boolean;
    @Input() public totalItemsPerRow: number;
    @Input() public isFromProprties:boolean;

    @Input()
    public set items(value: any) {
        if (value) {
            this.ITEMS = value;
            this.dataProcessing();
        }
    }
    constructor(private dialogManagerService :DialogManagerService){

    }

    public get items(): any {
        return this.ITEMS;
    }

    private ITEMS: any;
    public groups: any;
    public AuthentValue:string;

    public ngOnInit() {
    }

    public changeOidc(object,item) {
        if(object.displayName == 'Authentication Method'){
            if(item == 'OIDC'){
              this.dialogManagerService.showDialog({ title: 'Important Note', message: 'In order for the new setting to take effect, please restart DBmaestro services including relevant IIS services' }, null, MessageDialogComponent, 'message-dialog');
            }
            else if(this.AuthentValue == 'OIDC'){
                this.dialogManagerService.showDialog({ title: 'Important Note', message: 'In order for the new setting to take effect, please restart DBmaestro services including relevant IIS services' }, null, MessageDialogComponent, 'message-dialog');
            }
            this.AuthentValue = item
        }
    }

    private dataProcessing(): void {
            this.groups = this.items[0].optionsList.slice();
            const item = this.groups.find(x => x.displayName == "Authentication Method")
            this.AuthentValue = item.validValue ? item.validValue[0] : '';

        // this.groups.forEach((group) => {
        //     const groupOptions = [];
        //     const tempItems: any[] = group.optionsList.slice();
        //     const shift = tempItems.length % this.totalItemsPerRow !== 0 ? 1 : 0;
        //     const length = tempItems.length / this.totalItemsPerRow + shift;

        //     tempItems.forEach((item, index) => {
        //         item.idx = index;
        //     });
        //     for (let i = 0; i < length; i++) {
        //         const options = tempItems.splice(0, this.totalItemsPerRow);
        //         if (options.length > 0) {
        //             groupOptions.push(options.map(item => item));
        //         }
        //     }
        //     group.groupOptions = groupOptions;
        // });
    }

    public computeItemCss(last: boolean) {
        return last ? 'row items-style-last' : 'row items-style';
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/dbm-components/dbm-proprties-additional-options/dbm-additional-proprties.component.ts